import MenuOpenOutlinedIcon from "@mui/icons-material/MenuOpenOutlined"
import AppBar from "@mui/material/AppBar"
import IconButton from "@mui/material/IconButton"
import Link from "@mui/material/Link"
import Toolbar from "@mui/material/Toolbar"
import { styled } from "@mui/material/styles"
import { useState } from "react"
import { Link as RouterLink } from "react-router-dom"

import Row from "../../common/components/Row"
import NavLogo from "../../static/images/sidebar-icons/nav-logo.png"
import MobileSidebarLinksDrawer from "./components/MobileSidebarLinksDrawer"
import NavbarRightSection from "./components/NavbarRightSection"

export default function MobileAppBar() {
  const [sidebarDrawerOpen, setSidebarDrawerOpen] = useState(false)

  return (
    <StyledAppBar component="nav" variant="outlined" elevation={0}>
      <Toolbar>
        <Link component={RouterLink} to="/" lineHeight={0}>
          <img
            style={{ height: "32px", borderRadius: "6px" }}
            src={NavLogo}
            alt="OneBase logo"
          />
        </Link>
        <HeaderRow>
          <IconButton onClick={() => setSidebarDrawerOpen(true)}>
            <MenuOpenOutlinedIcon />
          </IconButton>
          <NavbarRightSection />
        </HeaderRow>
      </Toolbar>
      <MobileSidebarLinksDrawer
        open={sidebarDrawerOpen}
        onClose={() => setSidebarDrawerOpen(false)}
      />
    </StyledAppBar>
  )
}

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  display: "none",
  background: "white",
  position: "sticky",
  top: 0,
  borderInline: "none",
  borderTop: "none",
  [theme.breakpoints.only("xs")]: {
    display: "flex",
    borderRadius: "0 0 16px 16px",
    padding: "8px 0px",
    background:
      "linear-gradient(159deg, rgba(255, 255, 255, 0.25) 3.01%, rgba(255, 255, 255, 0.10) 103.3%)",
    backdropFilter: "blur(21px)",
    border: "none",
    boxShadow: "0 12px 45px rgba(0, 0, 0, 0.15)",
  },
}))

const HeaderRow = styled(Row)(({ theme }) => ({
  justifyContent: "space-between",
  alignItems: "center",
  marginLeft: theme.spacing(1),
  width: "100%",
}))
